import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const organizerCommonStoreSelector = (state: RootState) => state.organizer.common;

export const organizerIsLoadingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isLoading);
/** Производная от `loadedTournamentId`: запрос по какой-то организации уже отработал. */
export const organizerIsLoadedSelector = createSelector(organizerCommonStoreSelector, (state) => state.loadedTournamentId !== null);
export const organizerLoadedTournamentIdSelector = createSelector(organizerCommonStoreSelector, (state) => state.loadedTournamentId);
export const organizerErrorSelector = createSelector(organizerCommonStoreSelector, (state) => state.error);
export const organizerIsTeamCreatingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isTeamCreating);
export const organizerInfoSelector = createSelector(organizerCommonStoreSelector, (state) => state.info);
export const organizerIsTeamEditingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isTeamEditing);
export const organizerIsSavingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isSaving);
